module.exports = __webpack_public_path__ + "static/media/logo_v2.f423533e.png";